import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { CancelButton } from '../UtilitiesComponents/CancelButton';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { useGetUsersForFilterQuery } from '../../api/filter/dataFilterApi';
import { CircularProgress } from '@mui/joy';
import { SaveButton } from '../UtilitiesComponents/SaveButton';
import { useUpdateDealMutation } from '../../api/empresa/empresaApi';
import { ConfirmedDeal, UpdateDealRequest, Vendedor } from '../../types/empresa';
import { parseDateToInput, reverseDate } from '../../utils/calendarUtils';
import { useGetDealByIdQuery } from '../../api/empresa/dealApi';

interface Props {
    setShowModal: Dispatch<SetStateAction<boolean>>;
    deal: ConfirmedDeal;
}

export type VendedorInfo = {
    vendedorId: number;
    vendedorName: string;
}

export function EditarDealForm({ setShowModal, deal }: Props) {
    const [vendedoresAgregados, setVendedoresAgregados] = useState<VendedorInfo[]>([])
    const [vendedorSelected, setVendedorSelected] = useState<number>(0);
    const [addVendedorError, setAddVendedorError] = useState<string | null>(null);

    const { data: vendedores } = useGetUsersForFilterQuery({
        role: "Vendedor",
        dealId: deal.dealId.toString(),
        type: "exclude"
    }, { refetchOnMountOrArgChange: true });

    const { data: dealInfo, isSuccess } = useGetDealByIdQuery({ empresaId: deal.empresaId, dealId: deal.dealId}, { refetchOnMountOrArgChange: true })

    const [fechaVisita, setFechaVisita] = useState<string>();
    const [defaultFechaVisita, setDefaultFechaVisita] = useState<string>();

    const [updateDeal, { isLoading }] = useUpdateDealMutation();

    const addVendedor = () => {
        setAddVendedorError(null);

        if(vendedorSelected === 0) {
            setAddVendedorError("Debe seleccionar un vendedor")
            return;
        }

        // valida que no se agregue el mismo vendedor dos veces
        if(vendedoresAgregados.find((vendedor) => vendedor.vendedorId == vendedorSelected)) {
            setAddVendedorError("Este vendedor ya esta en agregado")
            return;
        }

        const vendedor = vendedores?.find((vendedor) => vendedor.id === vendedorSelected);

        const newVendedor: VendedorInfo = {
            vendedorName: vendedor?.nombre ?? "Sin nombre",
            vendedorId: vendedorSelected,
        };
        setVendedoresAgregados([...vendedoresAgregados, newVendedor]);

        // clear inputs
        setVendedorSelected(0);
    }

    const deleteVendedor = (index: number) => {
        vendedoresAgregados.splice(index, 1);

        setVendedoresAgregados([...vendedoresAgregados]);
    }

    const handleUpdate = async () => {
        try {
            setAddVendedorError(null);

            const newVendedores: Vendedor[] = [];
            vendedoresAgregados.map((vendedor) => newVendedores.push({
                id: vendedor.vendedorId,
                dealId: deal.dealId
            }))

            const request: UpdateDealRequest = {
                empresaId: deal.empresaId,
                dealId: deal.dealId,
                fechaVisita: fechaVisita as string,
                vendedores: newVendedores, 
            };

            await updateDeal(request).unwrap();

            setShowModal(false);
            
        } catch (error) {
            console.error(error);
        }

    }

    useEffect(() => {
        if(!isSuccess)
            return;

        const fecha = parseDateToInput( reverseDate(dealInfo.fechaVisita), dealInfo.horarioVisita);
        setFechaVisita(fecha);
        setDefaultFechaVisita(fecha);
    }, [dealInfo]);

    return (
        <div className="bg-white w-[650px] rounded">
            <div className="flex justify-end bg-gray-100 rounded">
                <button onClick={() => setShowModal(false)}>
                    <CloseRoundedIcon  />
                </button>
            </div>
            <div className="p-3">
                <p className="text-xl font-semibold mb-4">Editar Campaña</p>


                <label className="text-sm font-semibold">Fecha de la próxima visita</label>
                <input 
                    value={fechaVisita}
                    onChange={(event) => {
                        setFechaVisita(event.target.value);
                        console.log(event.target.value, " !== ", defaultFechaVisita, " -> ", event.target.value !== defaultFechaVisita);
                    }}
                    className="
                        w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                        font-semibold text-gray-600 text-sm"
                    type="datetime-local" />

                <p className="text-sm font-semibold">Agregar vendedor</p>
                <div className="flex items-center gap-x-2">
                    <select
                        value={vendedorSelected}
                        onChange={(event) => {
                            const vendedorId = parseInt(event.target.value);

                            if(isNaN(vendedorId))
                                return;

                            setVendedorSelected(vendedorId);
                        }}
                        className="
                            w-full h-[26px] rounded-[3px] border-gray-400 border my-1 px-2 
                            font-semibold text-gray-600 text-sm">
                        <option value={0} hidden>Seleccionar vendedor</option>
                        {vendedores?.map((vendedor, index) => (
                        <option value={vendedor.id} key={index}>{vendedor.nombre}</option>
                        ))}
                    </select>
                    <button
                        onClick={addVendedor}
                        type="button"
                        className="bg-slate-700 border-0 border-gray-300 h-[26px] rounded-[3px] px-[6px] py-[2px] flex gap-1 items-center text-sm text-white font-semibold">
                        Agregar
                    </button>
                </div>
                 
                <div className="h-[100px] max-h-[100px] overflow-auto my-2">
                    {vendedoresAgregados.length === 0
                    ? <p className="text-sm font-semibold text-gray-600 italic text-center">No hay vendedores agregados</p>
                    : vendedoresAgregados.map((vendedor, index) => (
                        <div 
                            key={index}
                            className="flex gap-x-2 justify-between hover:bg-slate-50 p-2 rounded-md">
                            <div className="flex gap-x-1">
                                <div className="w-[20px] h-[20px] bg-gray-500 rounded-full"></div>
                                <p className="text-sm font-semibold">{vendedor.vendedorName}</p>
                            </div>
                            <div 
                                className="flex items-center h-[20px] cursor-pointer hover:bg-red-200 rounded-md" 
                                onClick={() => deleteVendedor(index)}>
                                <CloseRoundedIcon sx={{ height: 20, width: 20 }}/>
                            </div>
                        </div>
                    ))}
                </div>

                {addVendedorError && (
                    <p className="valErrorText text-sm">{addVendedorError}</p>
                )}

                {isLoading
                ? 
                <div className="w-[105px] h-[27px] flex items-center justify-center">
                    <CircularProgress sx={{
                        "--CircularProgress-progressThickness": "4px",
                        "--CircularProgress-trackThickness": "4px",
                        "--CircularProgress-size": "25px"
                    }}/>
                </div>
                : <button 
                    onClick={handleUpdate}
                    disabled={vendedoresAgregados.length === 0 && fechaVisita == defaultFechaVisita || fechaVisita?.length === 0}
                    type="button"
                    className="bg-green-800 rounded-[3px] px-[6px] py-[2px] flex gap-1 items-center disabled:opacity-85">
                    <p className="text-white text-[13px] font-semibold text-center">Guardar</p>
                </button>
                }
            </div>
        </div>
    );

}